/**
 * @generated SignedSource<<10229a4d797e31b6f4826084c87056ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileOpportunities_userProfile$data = {
  readonly firstName: string | null;
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"AllProfileWorkOpportunityResultsListView_userAccount">;
  readonly " $fragmentType": "ProfileOpportunities_userProfile";
};
export type ProfileOpportunities_userProfile$key = {
  readonly " $data"?: ProfileOpportunities_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileOpportunities_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileOpportunities_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AllProfileWorkOpportunityResultsListView_userAccount"
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "eae9445ab32551308de75908ab290a6b";

export default node;
